var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85807 16.7592H7.14189C6.7817 16.7592 6.43626 16.6161 6.18157 16.3615C5.92688 16.1068 5.7838 15.7613 5.7838 15.4011V10.2472L0.752077 5.21547C0.497036 4.96195 0.352957 4.61762 0.35144 4.25802V1.82025C0.35144 1.46006 0.494524 1.11462 0.749216 0.859933C1.00391 0.605242 1.34934 0.462158 1.70953 0.462158H15.2904C15.6506 0.462158 15.996 0.605242 16.2507 0.859933C16.5054 1.11462 16.6485 1.46006 16.6485 1.82025V4.25802C16.647 4.61762 16.5029 4.96195 16.2479 5.21547L11.2162 10.2472V15.4011C11.2162 15.7613 11.0731 16.1068 10.8184 16.3615C10.5637 16.6161 10.2183 16.7592 9.85807 16.7592ZM1.70953 1.82025V4.25802L7.14189 9.69038V15.4011H9.85807V9.69038L15.2904 4.25802V1.82025H1.70953Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })));
};
export default SvgFilter;